<template>
  <div v-if="!routes[0].hidden">
    <template v-if="routes[0].children && routes[0].children.length > 0">
      <el-submenu
        popper-class="sidebar-submenu"
        :index="routes[0].name || routes[0].path"
        :key="routes[0].name"
      >
        <template slot="title">
          <icon
            v-if="routes[0].meta && routes[0].meta.icon"
            :name="routes[0].meta.icon"
          ></icon>
          <span
            v-if="routes[0].meta && routes[0].meta.title"
            class="text-ellipsis-2"
            :title="routes[0].meta.title"
            >{{ routes[0].meta.title }}</span
          >
        </template>

        <template v-for="subItem in routes[0].children">
          <template v-if="!subItem.hidden">
            <template v-if="subItem.children && subItem.children.length > 0">
              <sidebar-item
                class="nest-menu"
                :routes="[subItem]"
                :key="subItem.path"
              ></sidebar-item>
            </template>
            <router-link v-else :to="subItem.path" :key="subItem.name">
              <el-menu-item
                :index="subItem.path"
                :class="{
                  'is-active': isMenuItemActive(subItem),
                  'no-icon-padding': !subItem.meta.icon
                }"
              >
                <icon
                  v-if="subItem.meta && subItem.meta.icon"
                  :name="subItem.meta.icon"
                ></icon>
                <span
                  v-if="subItem.meta && subItem.meta.title"
                  class="text-ellipsis-2"
                  :title="subItem.meta.title"
                  >{{ subItem.meta.title }}</span
                >
              </el-menu-item>
            </router-link>
          </template>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array,
      required: true
    }
  },
  methods: {
    isMenuItemActive(item) {
      const currentPath = this.$route.path
      // 构建完整路径（考虑父级路径）
      const fullPath = item.path

      // 匹配逻辑：当前路径等于完整路径、别名路径，或以完整路径开头
      return (
        currentPath === fullPath ||
        currentPath === item.path || // 直接路径匹配
        (item.alias && currentPath === item.alias) || // 别名匹配
        currentPath.startsWith(fullPath)
      ) // 子路径匹配
    }
  }
}
</script>

<style>
.no-icon-padding {
  padding-left: 80px !important;
}
</style>
